import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Phone, KeyRound, LogIn } from "lucide-react";
import { toast } from "sonner";
import driverApi from "@/lib/driverApi";
import InstallPrompt from "@/components/InstallPrompt";

export default function DriverLogin() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!phone || !pin) {
      toast.error("Unesite broj telefona i PIN.");
      return;
    }
    setBusy(true);
    try {
      const { data } = await driverApi.post("/driver/login", { phone, pin });
      localStorage.setItem("juke_driver_token", data.access_token);
      navigate("/driver/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Pogrešan broj telefona ili PIN.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="driver-login-page"
      className="min-h-screen bg-[#050505] text-zinc-100 flex flex-col"
    >
      <div className="pt-14 pb-6 text-center">
        <div className="inline-flex items-baseline gap-2">
          <span className="font-display text-3xl text-white">Juke</span>
          <span className="font-display text-3xl text-[#C5A059] italic">Transfers</span>
        </div>
        <p className="mt-2 text-[11px] uppercase tracking-[0.3em] text-zinc-500">Vozački portal</p>
      </div>

      <form
        onSubmit={submit}
        className="flex-1 px-6 max-w-md w-full mx-auto flex flex-col justify-center gap-5"
      >
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-zinc-400 mb-2 block">
            Broj telefona
          </label>
          <div className="relative">
            <Phone className="w-5 h-5 text-zinc-500 absolute left-4 top-1/2 -translate-y-1/2" />
            <input
              data-testid="driver-phone-input"
              type="tel"
              autoComplete="tel"
              inputMode="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+385 91 …"
              className="w-full h-14 pl-12 pr-4 rounded-xl bg-[#0d0d0d] border border-white/10 focus:border-[#C5A059] focus:ring-1 focus:ring-[#C5A059]/40 text-lg text-white placeholder:text-zinc-600 outline-none transition-colors"
            />
          </div>
        </div>

        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-zinc-400 mb-2 block">
            PIN kod
          </label>
          <div className="relative">
            <KeyRound className="w-5 h-5 text-zinc-500 absolute left-4 top-1/2 -translate-y-1/2" />
            <input
              data-testid="driver-pin-input"
              type="password"
              inputMode="numeric"
              autoComplete="current-password"
              maxLength={8}
              value={pin}
              onChange={(e) => setPin(e.target.value.replace(/[^0-9]/g, ""))}
              placeholder="••••"
              className="w-full h-14 pl-12 pr-4 rounded-xl bg-[#0d0d0d] border border-white/10 focus:border-[#C5A059] focus:ring-1 focus:ring-[#C5A059]/40 text-2xl tracking-[0.5em] text-white placeholder:text-zinc-700 outline-none transition-colors"
            />
          </div>
        </div>

        <button
          type="submit"
          data-testid="driver-login-submit"
          disabled={busy}
          className="mt-3 h-14 rounded-xl bg-[#C5A059] hover:bg-[#D4AF37] disabled:opacity-50 text-black font-semibold text-lg flex items-center justify-center gap-2 transition-colors"
        >
          <LogIn className="w-5 h-5" />
          {busy ? "Prijava…" : "Prijavi se"}
        </button>

        <p className="text-center text-xs text-zinc-500 mt-4">
          Ako trebate resetirati broj telefona ili PIN, javite se uredu.
        </p>
      </form>
      <InstallPrompt />
    </div>
  );
}
